{
    "title": "ابدأ من هنا",
    "subtitle": "ما هذه المنصّة، وما الذي ينبغي لمن في دورك أن يطّلع عليه أولاً. كل رقم أدناه عدّ لسجلات محمّلة فعلاً، وكل خطوة تفتح شاشة عاملة.",

    "tour": {
        "yours": "جولتك",
        "for": "مكتوبة لـ{{roles}}",
        "minutes": "نحو {{count}} دقيقة",
        "open": "افتح",
        "step": "الخطوة {{number}}",
        "others": "جولات لأدوار أخرى",
        "switch": "اعرض هذه الجولة"
    },

    "pillars": {
        "title": "عميل واحد، أربع وحدات",
        "help": "الشكوى والمكالمة وزيارة الفرع ورد الاستبيان كلها للشخص نفسه. ولا شيء أدناه نظام منفصل له نسخته الخاصة من العميل.",
        "spine": "السجل الموحّد للعميل",
        "spine_help": "سجل واحد لكل شخص، أياً كان المعرّف الذي تصل به.",
        "complaints": "الشكاوى",
        "complaints_help": "الاستقبال والتوجيه والمهلة والإغلاق، وفق تقويم العمل العُماني.",
        "contact_centre": "مركز الاتصال",
        "contact_centre_help": "المكالمات والدردشة والبريد والتواصل الاجتماعي في وحدة تحكم واحدة.",
        "queue": "طابور الفرع",
        "queue_help": "الكشك والكاونتر وشاشة الصالة، مع تقدير انتظار صادق.",
        "measurement": "قياس التجربة",
        "measurement_help": "مؤشرات NPS وCSAT وCES، والعربية تُحلَّل بالعربية.",

        "record_customers": "عميل",
        "record_timeline_entries": "مدخل زمني",
        "record_complaints": "شكوى",
        "record_categories": "تصنيف",
        "record_conversations": "محادثة",
        "record_agents": "وكيل",
        "record_tickets": "تذكرة",
        "record_branches": "فرع",
        "record_responses": "رد",
        "record_surveys": "استبيان"
    },

    "compliance": {
        "title": "تغطية المتطلبات",
        "help": "مشتقة من التعليقات التوضيحية في الشيفرة، لا محفوظة يدوياً. افتح المصفوفة لترى الشيفرة والاختبارات خلف كل متطلب.",
        "mandatory": "إلزامي",
        "essential": "أساسي",
        "desirable": "مرغوب",
        "of": "{{implemented}} من {{total}}",
        "open": "افتح المصفوفة"
    },

    "scenarios": {
        "title": "سيناريوهات معدّة",
        "help": "عروض قصيرة يجيب كل منها عن سؤال واحد، في لوحة التحكم.",
        "open": "افتح لوحة التحكم"
    }
}
